// extracted by mini-css-extract-plugin
module.exports = {"pins":"MapWindStationPins_pins__j5LpW"};